import type { TablePaginationConfig } from 'antd/lib/table'
import { mergeDeepRight } from 'ramda'
import Table from './Table'
import { TableChangeHandler } from '@lib/hooks/useSearch'
import React from 'react'
import { TableProps } from './table.type'
import Pagination from '@components/ui/Pagination'

export default function QueryTable<T = any>({
  rowKey = 'id',
  pagination = {},
  dataSource,
  onChange,
  columns,
  ...props
}: TableProps<T>) {
  let paginationConfig: any = mergeDeepRight<any, any>(
    {
      pageSize: dataSource?.pageSize ?? 10,
      current: dataSource?.page ?? 1, //[fixed]: antd[Table] current should be positive  number
      total: dataSource?.total ?? 0,
      position: ['bottomLeft'],
      simple: false,
      showSizeChanger: false,
    },
    pagination
  ) as TablePaginationConfig

  if (pagination === false) {
    paginationConfig = false
  }

  React.useEffect(() => {
    if (!paginationConfig) {
      return
    }
    const { total = 1, pageSize = 1, current = 1 } = paginationConfig
    const lastPage = Math.ceil(total / pageSize)
    if (current > lastPage) {
      onChange &&
        onChange(
          { current: lastPage, pageSize },
          {},
          {},
          {
            currentDataSource: [],
            action: 'paginate',
          }
        )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationConfig])

  const handleChange: TableChangeHandler<T> = (...args) => {
    onChange && onChange(...args)
  }

  return (
    <>
      <Table
        rowKey={rowKey}
        dataSource={dataSource?.content}
        pagination={false}
        // onChange={handleChange}
        columns={columns?.filter(c => !c.hidden)}
        {...props}
      />
      {paginationConfig && (
        <Pagination
          className="float-right mt-20"
          {...paginationConfig}
          onChange={(page, pageSize) =>
            handleChange(
              { ...paginationConfig, current: page, pageSize },
              {},
              {}
            )
          }
        />
      )}
    </>
  )
}
